import type { ReactNode } from 'react';
import { Sidebar, SidebarProvider } from '@/components/ui/sidebar';
import { AppHeader } from './AppHeader';
import { AppSidebar } from './AppSidebar';

interface AppLayoutProps {
  readonly children: ReactNode;
  readonly onLoginClick?: () => void;
}

export function AppLayout({ children, onLoginClick }: AppLayoutProps) {
  return (
    <SidebarProvider forceOverlay>
      <div className="flex min-h-screen flex-1 flex-col bg-background max-w-[100vw] overflow-x-hidden">
        <AppHeader onLoginClick={onLoginClick} />
        <Sidebar>
          <AppSidebar />
        </Sidebar>
        <main className="flex-1 py-6">
          <div className="mx-auto w-full max-w-6xl px-4">{children}</div>
        </main>
      </div>
    </SidebarProvider>
  );
}
